__turbopack_context__.v({
  "active": "styles-module__n_yxUq__active",
  "icon": "styles-module__n_yxUq__icon",
  "link": "styles-module__n_yxUq__link",
});
